import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import api from '../../../../Services/api';
 
const EstablishmentMonthlyCompliance = ({month,year,division}) => {

  const [data, setData] = useState([]);
  const [monthlyData, setMonthlyData] = useState([]);
 
  const headers = [
    'Sl No',
    'Establishment',
    'Address',
    'Contact Person',
    'Contact No',
    'Escalation Contact No',
    'Email Id',
    'Escalation Email Id',

    'The Goods And Service Tax Outward Supplies',
    'The Goods And Service Tax Summary Return',
    'Factory Half Year Return',
    'Factory Annual Returns',
    'Fire Safety Training',
    'Environmental Audit Report',
    'Direct Greenhouse Gas GHGEmissions',
    'Indirect GHGEmissions',
    'All Other Indirect Emissions In The Value Chain',
    'Total Energy Consumed Renewable Sources',
    'Total Energy Consumed Non Renewable Sources',
    'Water Consumed',
    'Total Amount Ofwaste Generated',
    'Cap Ex On Green Initiatives',
    'Penalties And Fines Paid Due To Environmental Issues',
    'Opex On Green Initiatives',
    'CSRBudget As APercent Of Profits',
    'Percent Of CSRBudget Utilized',
    'Hazardous Waste Annual Returns',
    'Pressure Vessel Report',
    'Epfo Ecr And Remittance Confirmation Challan',
    'Epfo Paid Challan Copy And Date',
    'Epfo Copy Of Return To International Workers',
    'Esic Monthly Contribution History And Challans',
    'Esic Half Yearly Returns Maintain Half Yearly Return',
    'Tax On Professions',
    'Labour Welfare Fund',
    'Labour Welfare Fund Form D',
    'Clra Rc Annual Returns',
    'Payment Of Bonus Act Return Annexure',
    'Payment Of Bonus Act Return Acknowledgment Copy',
    'Employee Turnover Rate',
    'Average Hours Of Training Per Employee',
    'Gender Pay Gap',
    'Workforce Demographics',
    'Percentage Of Independent Directors On The Board',
    'Board Diversity',
    'Total Employee Compensation And Benefits',
    'Total Expenditure On Employee Training',
    'Capex On Employee Welfare Initiatives',
    'Annual Returns POSHAct2013',
    'Pending Cases POSHAct2013',
    'Accident Report Submission',
    'Pending Notice From Govt Bodies',

    
    'Complied Percentage',
    'Not Complied Percentage'
  ];
 


let data1 = sessionStorage.getItem('user');
let clientData = JSON.parse(data1);

let id=clientData.id;




  useEffect(() => {
    const fetchData = async () => {
      try {
        if(division === '' || division === 'NoDivision'){
        const response = await api.Corporate.getAllEstMonthlyreport(id,month,year) ;
        const result = response.data ;
     
        if (Array.isArray(result.data.Profile) ) {
          setData(result.data.Profile);
          setMonthlyData(result.data.EstablishmentMonthlyData)
        } else {
          console.error('Profile is not an array', result.data.Profile);
          setData([]);
        }
      }
      else{
         const response = await api.Corporate.getAllEstMonthlyreport(id,month,year,division) ;
        const result = response.data ;
     
        if (Array.isArray(result.data.Profile) ) {
          setData(result.data.Profile);
          setMonthlyData(result.data.EstablishmentMonthlyData)
        } else {
          console.error('Profile is not an array', result.data.Profile);
          setData([]);
        }
      }
      } catch (error) {
        console.error('Error fetching data:', error);
        setData([]);
      }
    };
 
    fetchData();
  }, [id,month,year,division]);
 
  // Function to generate Excel file
  const handleExport = () => {
    // Mapping API data to Excel sheet format
    const mappedData = data.map((item, index) => {
      const masterItem = monthlyData.find((master) => master.companyId === item.companyId);
 
      const getValidationStatus = (field) => {
        if (!masterItem || !masterItem[field]) {
          return 'NA';
        }
        return masterItem[field]?.na && masterItem[field].validation === 2
        ? 'Not Applicable'
        : masterItem[field].validation === 2
          ? 'Complied'
          : masterItem[field].validation === 3
            ? 'Non-Complied'
             :masterItem[field].validation === null
              ? 'Not Available'
               : 'NA'; // or some default value
     
            };
      return {
        'Sl No': index + 1,  // Automatically generate Sl No starting from 1
        'Name of Contractor/Sub-Contractor': item?.clientName ? item?.clientName : 'N/A',
        'Address': (item?.clientAddress ? item.clientAddress + ', ' : ''),
        'Contact Person': item.clientContactPersonName,
        'Contact No': item.clientContactPersonPhoneNumber,
        'Escalation Contact No': item.clientContactPersonPhoneNumber1 || 'N/A',
        'Email Id': item.clientContactPersonEmailId,
        'Escalation Email Id': item.clientContactPersonEmailId1 || 'N/A',

        'The Goods And Service Tax Outward Supplies': masterItem ? getValidationStatus('TheGoodsAndServiceTaxOutwardSupplies') : 'N/A',
        'The Goods And Service Tax Summary Return': masterItem ? getValidationStatus('TheGoodsAndServiceTaxSummaryReturn') : 'N/A',
        'Factory Half Year Return': masterItem ? getValidationStatus('FactoryHalfYearReturn') : 'N/A',
        'Factory Annual Returns': masterItem ? getValidationStatus('FactoryAnnualReturns') : 'N/A',
        'Fire Safety Training': masterItem ? getValidationStatus('FireSafetyTraining') : 'N/A',
        'Environmental Audit Report': masterItem ? getValidationStatus('EnvironmentalAuditReport') : 'N/A',
        'Direct Greenhouse Gas GHGEmissions': masterItem ? getValidationStatus('DirectGreenhouseGasGHGEmissions') : 'N/A',
        'Indirect GHGEmissions': masterItem ? getValidationStatus('IndirectGHGEmissions') : 'N/A',
        'All Other Indirect Emissions In The Value Chain': masterItem ? getValidationStatus('AllOtherIndirectEmissionsInTheValueChain') : 'N/A',
        'Total Energy Consumed Renewable Sources': masterItem ? getValidationStatus('TotalEnergyConsumedRenewableSources') : 'N/A',
        'Total Energy Consumed Non Renewable Sources': masterItem ? getValidationStatus('TotalEnergyConsumedNonRenewableSources') : 'N/A',
        'Water Consumed': masterItem ? getValidationStatus('WaterConsumed') : 'N/A',
        'Total Amount Ofwaste Generated': masterItem ? getValidationStatus('TotalAmountOfwasteGenerated') : 'N/A',
        'Cap Ex On Green Initiatives': masterItem ? getValidationStatus('CapExOnGreenInitiatives') : 'N/A',
        'Penalties And Fines Paid Due To Environmental Issues': masterItem ? getValidationStatus('PenaltiesAndFinesPaidDueToEnvironmentalIssues') : 'N/A',
        'Opex On Green Initiatives': masterItem ? getValidationStatus('OpexOnGreenInitiatives') : 'N/A',
        'CSRBudget As APercent Of Profits': masterItem ? getValidationStatus('CSRBudgetAsAPercentOfProfits') : 'N/A',
        'Percent Of CSRBudget Utilized': masterItem ? getValidationStatus('PercentOfCSRBudgetUtilized') : 'N/A',
        'Hazardous Waste Annual Returns': masterItem ? getValidationStatus('HazardousWasteAnnualReturns') : 'N/A',
        'Pressure Vessel Report': masterItem ? getValidationStatus('PressureVesselReport') : 'N/A',
        'Epfo Ecr And Remittance Confirmation Challan': masterItem ? getValidationStatus('EpfoEcrAndRemittanceConfirmationChallan') : 'N/A',
        'Epfo Paid Challan Copy And Date': masterItem ? getValidationStatus('EpfoPaidChallanCopyAndDate') : 'N/A',
        'Epfo Copy Of Return To International Workers': masterItem ? getValidationStatus('EpfoCopyOfReturnToInternationalWorkers') : 'N/A',
        'Esic Monthly Contribution History And Challans': masterItem ? getValidationStatus('EsicMonthlyContributionHistoryAndChallans') : 'N/A',
        'Esic Half Yearly Returns Maintain Half Yearly Return': masterItem ? getValidationStatus('EsicHalfYearlyReturnsMaintainHalfYearlyReturn') : 'N/A',
        'Tax On Professions': masterItem ? getValidationStatus('TaxOnProfessions') : 'N/A',
        'Labour Welfare Fund': masterItem ? getValidationStatus('LabourWelfareFund') : 'N/A',
        'Labour Welfare Fund Form D': masterItem ? getValidationStatus('LabourWelfareFundFormD') : 'N/A',
        'Clra Rc Annual Returns': masterItem ? getValidationStatus('ClraRcAnnualReturns') : 'N/A',
        'Payment Of Bonus Act Return Annexure': masterItem ? getValidationStatus('PaymentOfBonusActReturnAnnexure') : 'N/A',
        'Payment Of Bonus Act Return Acknowledgment Copy': masterItem ? getValidationStatus('PaymentOfBonusActReturnAcknowledgmentCopy') : 'N/A',
        'Employee Turnover Rate': masterItem ? getValidationStatus('EmployeeTurnoverRate') : 'N/A',
        'Average Hours Of Training Per Employee': masterItem ? getValidationStatus('AverageHoursOfTrainingPerEmployee') : 'N/A',
        'Gender Pay Gap': masterItem ? getValidationStatus('GenderPayGap') : 'N/A',
        'Workforce Demographics': masterItem ? getValidationStatus('WorkforceDemographics') : 'N/A',
        'Percentage Of Independent Directors On The Board': masterItem ? getValidationStatus('PercentageOfIndependentDirectorsOnTheBoard') : 'N/A',
        'Board Diversity': masterItem ? getValidationStatus('BoardDiversity') : 'N/A',
        'Total Employee Compensation And Benefits': masterItem ? getValidationStatus('TotalEmployeeCompensationAndBenefits') : 'N/A',
        'Total Expenditure On Employee Training': masterItem ? getValidationStatus('TotalExpenditureOnEmployeeTraining') : 'N/A',
        'Capex On Employee Welfare Initiatives': masterItem ? getValidationStatus('CapexOnEmployeeWelfareInitiatives') : 'N/A',
        'Annual Returns POSHAct2013': masterItem ? getValidationStatus('AnnualReturnsPOSHAct2013') : 'N/A',
        'Pending Cases POSHAct2013': masterItem ? getValidationStatus('PendingCasesPOSHAct2013') : 'N/A',
        'Accident Report Submission': masterItem ? getValidationStatus('AccidentReportSubmission') : 'N/A',
        'Pending Notice From Govt Bodies': masterItem ? getValidationStatus('PendingNoticeFromGovtBodies') : 'N/A',

        'Complied': masterItem ? masterItem.AcceptedPercent+"%" : 'N/A',
        'Non-Complied': masterItem ? masterItem.RejectedPercent+"%" : 'N/A',
      };
    });
 
    // const
 
    // Create worksheet from the data
    const ws = XLSX.utils.json_to_sheet(mappedData);
 
    // Add headers manually to the worksheet
    XLSX.utils.sheet_add_aoa(ws, [headers], { origin: 'A1' });
 
 
    // Style the worksheet (optional)
    const wsCols = [
      { wpx: 50 }, // Sl No
      { wpx: 250 }, // Name of Contractor/Sub-Contractor
      { wpx: 300 }, // Address
      { wpx: 200 }, // Contact Person
      { wpx: 100 }, // Contact No
      { wpx: 100 }, // Escalation Contact No
      { wpx: 250 }, // Email Id
      { wpx: 250 }, // Escalation Email Id
      { wpx: 100 }, // CLRA License No
      { wpx: 100 }, // No. of Workers
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // BOCW RC No
      { wpx: 100 }, // No. of Workers
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // WC Number
      { wpx: 100 }, // No. of Workers Covered
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
      { wpx: 100 }, // Valid Date
 
    ];
 
    ws['!cols'] = wsCols; // Apply column widths
 
    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Contractor Report');
 
    // Write the workbook to a file
    XLSX.writeFile(wb, `LCR Report ${month}, ${year} .xlsx`);
  };
 
  return (
    <div>
    
      <button className='btn btn-danger btn-sm mb-2 ' onClick={handleExport}>Download Excel</button>
      {/* Optionally display the fetched data in a table */}
      <div style={{ minHeight: "420px",maxHeight: "420px", marginTop:"10px", overflowY: "auto" }}>
      <table style={{ width: '100%' }}>
        <thead  className="position-sticky top-0 " style={{ backgroundColor: 'black', color: 'white', fontWeight: 'bold' }}>
          <tr>
            {headers.map((header, index) => (
              <th key={index} >{header}</th>
            ))}
          </tr>
        </thead>
<tbody>
  {Array.isArray(data) && data.length > 0 ? (
    data.map((item, index) => {
      // Find the corresponding master item for the vendor
      const masterItem = monthlyData.find((master) => master.companyId === item.companyId);
 
      // Helper function to check for validation
      const getComplianceStatus = (field) => {
        if (!masterItem || !masterItem[field]) {
          return 'NA'; // If no corresponding master item or field, show 'NA'
        }
        // return masterItem[field].validation === 2 ? 'complied' : masterItem[field].validation === 3 ? 'non-complied' ? masterItem[field].na === true && masterItem[field].validation === 2 ? 'NA' : 'NA'  ;
        return masterItem[field]?.na && masterItem[field].validation === 2
  ? 'Not Applicable'
  : masterItem[field].validation === 2
    ? 'Complied'
    : masterItem[field].validation === 3
      ? 'Non-Complied'
       :masterItem[field].validation === null
        ? 'Not Available'
         : 'NA'; // or some default value
 
      };
 
      return (
        <tr key={index}>
          <td  >{index + 1}</td>
          <td  >{item.clientName}</td>
          <td  >{item.clientAddress}</td>
          <td  >{item.clientContactPersonName}</td>
          <td  >{item.clientContactPersonPhoneNumber}</td>
          <td  >{item.clientContactPersonPhoneNumber1 ? item.clientContactPersonPhoneNumber1 : 'NA'}</td>
          <td  >{item.clientContactPersonEmailId}</td>
          <td  >{item.clientContactPersonEmailId1 ? item.clientContactPersonEmailId1 : 'NA'}</td>

         
          {/* Using the helper function to determine compliance for each field */}
          <td  >{getComplianceStatus('TheGoodsAndServiceTaxOutwardSupplies')}</td>
          <td  >{getComplianceStatus('TheGoodsAndServiceTaxSummaryReturn')}</td>
          <td  >{getComplianceStatus('FactoryHalfYearReturn')}</td>
          <td  >{getComplianceStatus('FactoryAnnualReturns')}</td>
          <td  >{getComplianceStatus('FireSafetyTraining')}</td>
          <td  >{getComplianceStatus('EnvironmentalAuditReport')}</td>
          <td  >{getComplianceStatus('DirectGreenhouseGasGHGEmissions')}</td>
          <td  >{getComplianceStatus('IndirectGHGEmissions')}</td>
          <td  >{getComplianceStatus('AllOtherIndirectEmissionsInTheValueChain')}</td>
          <td  >{getComplianceStatus('TotalEnergyConsumedRenewableSources')}</td>
          <td  >{getComplianceStatus('TotalEnergyConsumedNonRenewableSources')}</td>
          <td  >{getComplianceStatus('WaterConsumed')}</td>
          <td  >{getComplianceStatus('TotalAmountOfwasteGenerated')}</td>
          <td  >{getComplianceStatus('CapExOnGreenInitiatives')}</td>
          <td  >{getComplianceStatus('PenaltiesAndFinesPaidDueToEnvironmentalIssues')}</td>
          <td  >{getComplianceStatus('OpexOnGreenInitiatives')}</td>
          <td  >{getComplianceStatus('CSRBudgetAsAPercentOfProfits')}</td>
          <td  >{getComplianceStatus('PercentOfCSRBudgetUtilized')}</td>
          <td  >{getComplianceStatus('HazardousWasteAnnualReturns')}</td>
          <td  >{getComplianceStatus('PressureVesselReport')}</td>
          <td  >{getComplianceStatus('EpfoEcrAndRemittanceConfirmationChallan')}</td>
          <td  >{getComplianceStatus('EpfoPaidChallanCopyAndDate')}</td>

          <td  >{getComplianceStatus('EpfoCopyOfReturnToInternationalWorkers')}</td>
          <td  >{getComplianceStatus('EsicMonthlyContributionHistoryAndChallans')}</td>
          <td  >{getComplianceStatus('EsicHalfYearlyReturnsMaintainHalfYearlyReturn')}</td>
          <td  >{getComplianceStatus('TaxOnProfessions')}</td>
          <td  >{getComplianceStatus('LabourWelfareFund')}</td>
          <td  >{getComplianceStatus('LabourWelfareFundFormD')}</td>
          <td  >{getComplianceStatus('ClraRcAnnualReturns')}</td>
          <td  >{getComplianceStatus('PaymentOfBonusActReturnAnnexure')}</td>
          <td  >{getComplianceStatus('PaymentOfBonusActReturnAcknowledgmentCopy')}</td>
          <td  >{getComplianceStatus('EmployeeTurnoverRate')}</td>
          <td  >{getComplianceStatus('AverageHoursOfTrainingPerEmployee')}</td>
          <td  >{getComplianceStatus('GenderPayGap')}</td>
          <td  >{getComplianceStatus('WorkforceDemographics')}</td>
          <td  >{getComplianceStatus('PercentageOfIndependentDirectorsOnTheBoard')}</td>

          <td  >{getComplianceStatus('BoardDiversity')}</td>
          <td  >{getComplianceStatus('TotalEmployeeCompensationAndBenefits')}</td>
          <td  >{getComplianceStatus('TotalExpenditureOnEmployeeTraining')}</td>
          <td  >{getComplianceStatus('CapexOnEmployeeWelfareInitiatives')}</td>
          <td  >{getComplianceStatus('AnnualReturnsPOSHAct2013')}</td>
          <td  >{getComplianceStatus('PendingCasesPOSHAct2013')}</td>
          <td  >{getComplianceStatus('AccidentReportSubmission')}</td>
          <td  >{getComplianceStatus('PendingNoticeFromGovtBodies')}</td>

          <td  >{masterItem ? masterItem?.AcceptedPercent + "%" : "N/A"}</td>
          <td  >{masterItem ? masterItem?.RejectedPercent + "%" : "N/A"}</td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan={headers.length}>No data available</td>
    </tr>
  )}
</tbody>
 
      </table>
      </div>
    </div>
  );
};
 
export default EstablishmentMonthlyCompliance;